import DocumentIcon from "@mui/icons-material/Description";
import CreditCard from "@mui/icons-material/CreditCard";
import NotesIcon from "@mui/icons-material/Assignment";
import TrainingIcon from "@mui/icons-material/School";
import GppGoodIcon from '@mui/icons-material/GppGood';
import WorkIcon from "@mui/icons-material/Work";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PolicyIcon from "@mui/icons-material/Policy";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import BuildIcon from "@mui/icons-material/Build";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import InfoIcon from "@mui/icons-material/Info";
import SettingsIcon from "@mui/icons-material/Settings";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import MapIcon from "@mui/icons-material/Map";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import DescriptionIcon from "@mui/icons-material/Description";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ShieldIcon from "@mui/icons-material/Shield";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import React from "react";

export const option = [
    // Safety category
    {
        name: 'Safety Stand Down',
        displayName: 'Safety Stand Down / Coaching',
        featureKey: 'safety_stand_down',
        icon: <GppGoodIcon fontSize="large" />,
        link: '/ssd',
        color: '#f44336',
        description: 'Safety Stand Down & Coaching Forms',
        category: 'safety',
        searchTerms: ['safety', 'ssd', 'stand down', 'coaching']
    },
    {
        name: 'Incidents',
        displayName: 'Initial Incident Communication',
        featureKey: 'frontend_incidents',
        icon: <ReportProblemIcon fontSize="large" />,
        link: '/incidents',
        color: '#e91e63',
        description: 'Initial Incident Communications',
        category: 'safety',
        searchTerms: ['safety', 'incident', 'accident', 'communication']
    },
    {
        name: 'OSHA Guidelines',
        displayName: 'OSHA/DHEC Guidelines',
        featureKey: 'frontend_osha_guidelines',
        icon: <PolicyIcon fontSize="large" />,
        link: '/osha-guidelines',
        color: '#ff5722',
        description: 'Inspection Procedures',
        category: 'safety',
        searchTerms: ['safety', 'osha', 'dhec', 'guidelines', 'inspection']
    },
    {
        name: 'Daily Log',
        displayName: 'Safety Daily Log',
        featureKey: 'frontend_daily_log',
        icon: <EventNoteIcon fontSize="large" />,
        link: '/daily-log',
        color: '#00796b',
        description: 'Safety Daily Activity Log',
        roles: ['ROLE_TRAINER', 'ROLE_ADMIN'],
        category: 'safety',
        searchTerms: ['safety', 'daily log', 'log', 'activity']
    },
    {
        name: 'Job Site Safety Inspection',
        displayName: 'Job Site Safety Inspection',
        featureKey: 'job_site_safety_inspection',
        icon: <AssignmentIcon fontSize="large" />,
        link: '/safety/forms/job-site-safety-inspection/list',
        color: '#d32f2f',
        description: 'Job Site Safety Inspection Checklist',
        category: 'safety',
        searchTerms: ['safety', 'inspection', 'checklist', 'job site']
    },
    {
        name: 'Spotter Training',
        displayName: 'Spotter Training',
        featureKey: 'frontend_spotter_training',
        icon: <GppGoodIcon fontSize="large" />,
        link: '/training/forms/spotter-training/list',
        color: '#d32f2f',
        description: 'Spotter Training Form',
        category: 'safety',
        searchTerms: ['safety', 'spotter', 'training', 'equipment operator', 'vehicle spotter', 'backing']
    },
    {
        name: 'Confined Space Entry Permit',
        displayName: 'Confined Space Entry Permit',
        featureKey: 'confined_space_entry_permit',
        icon: <GppGoodIcon fontSize="large" />,
        link: '/csep',
        color: '#c62828',
        description: 'Confined Space Entry Permit (CSEP)',
        category: 'safety',
        searchTerms: ['safety', 'confined', 'space', 'entry', 'permit', 'csep', 'hazard', 'confined space']
    },
    {
        name: 'Lock-Tag-Try Checklist (<600V)',
        displayName: 'Lock-Tag-Try Checklist (<600V)',
        featureKey: 'lock_tag_try_permit',
        icon: <GppGoodIcon fontSize="large" />,
        link: '/ltt',
        color: '#b71c1c',
        description: 'Lock-Tag-Try Checklist (<600V)',
        category: 'safety',
        searchTerms: ['safety', 'lock', 'tag', 'try', 'loto', 'lockout', 'tagout', 'permit', 'electrical', '600v', 'ltt']
    },
    {
        name: 'Fall Arrest Rescue Plan',
        displayName: 'Fall Arrest Rescue Plan',
        featureKey: 'frontend_fall_arrest_rescue_plan',
        icon: <GppGoodIcon fontSize="large" />,
        link: '/safety/forms/fall-arrest-rescue-plan',
        color: '#d32f2f',
        description: 'Fall Arrest Rescue Plan',
        category: 'safety',
        searchTerms: ['safety', 'fall', 'arrest', 'rescue', 'plan', 'height', 'fall protection', 'jha', 'work at height']
    },
    // Training category
    {
        name: 'MEWPS Proficiency',
        displayName: 'MEWPS Proficiency',
        featureKey: 'frontend_practical_evaluation',
        icon: <FactCheckIcon fontSize="large" />,
        link: '/training-due/practical-evaluation',
        color: '#7b1fa2',
        description: 'MEWPS Aerial/Scissor Lift Proficiency Evaluation',
        category: 'training',
        searchTerms: ['training', 'mewps', 'proficiency', 'aerial', 'scissor', 'lift', 'boom', 'evaluation']
    },
    {
        name: 'Forklift Proficiency',
        displayName: 'Forklift Proficiency',
        featureKey: 'frontend_forklift_proficiency',
        icon: <FactCheckIcon fontSize="large" />,
        link: '/training-due/forklift-proficiency',
        color: '#e65100',
        description: 'Forklift Operator Proficiency Evaluation',
        category: 'training',
        searchTerms: ['training', 'forklift', 'proficiency', 'counterbalance', 'telehandler', 'operator', 'evaluation']
    },
    {
        name: 'TBT',
        displayName: 'TBT',
        featureKey: 'tool_box_talk',
        icon: <DocumentIcon fontSize="large" />,
        link: '/tbt',
        color: '#2196f3',
        description: 'Tool Box Talks',
        category: 'training',
        searchTerms: ['training', 'tbt', 'toolbox', 'tool box', 'toolboxtalk', 'talks']
    },
    {
        name: 'Training',
        displayName: 'Training',
        featureKey: 'training_form',
        icon: <TrainingIcon fontSize="large" />,
        link: '/training-due',
        color: '#9c27b0',
        description: 'Training Due',
        roles: ['ROLE_TRAINER'],
        category: 'training',
        searchTerms: ['training', 'due', 'courses']
    },
    // Operations category - reordered
    {
        name: 'Weekly Roster',
        displayName: 'Weekly Roster',
        featureKey: 'frontend_weekly_roster',
        icon: <CalendarTodayIcon fontSize="large" />,
        link: '/admin/weekly-employee',
        color: '#3f51b5',
        description: 'Weekly Employee Roster',
        category: 'operations',
        searchTerms: ['operations', 'roster', 'weekly', 'employee', 'schedule']
    },
    {
        name: 'Timesheet',
        displayName: 'Timesheet',
        featureKey: 'frontend_timesheet',
        icon: <AccessTimeIcon fontSize="large" />,
        link: '/timesheet',
        color: '#673ab7',
        description: 'In Development',
        category: 'operations',
        searchTerms: ['operations', 'timesheet', 'time', 'hours']
    },
    {
        name: 'PTO / Bereavement',
        displayName: 'PTO / Bereavement Request',
        featureKey: 'frontend_pto_bereavement',
        icon: <BeachAccessIcon fontSize="large" />,
        link: '/timesheet/pto',
        color: '#673ab7',
        description: 'In Development',
        category: 'operations',
        searchTerms: ['operations', 'pto', 'bereavement', 'vacation', 'leave', 'time off', 'timesheet']
    },
    {
        name: 'JHA',
        displayName: 'JHA',
        featureKey: 'jha',
        icon: <WorkIcon fontSize="large" />,
        link: '/jha',
        color: '#795548',
        description: 'Job Hazard Analysis',
        category: 'operations',
        searchTerms: ['operations', 'jha', 'job hazard', 'hazard analysis', 'analysis']
    },
    {
        name: 'Tools',
        displayName: 'Tools',
        featureKey: 'frontend_tools',
        icon: <BuildIcon fontSize="large" />,
        link: '/tools',
        color: '#ff6f00',
        description: 'In Development',
        category: 'tools_equipment',
        searchTerms: ['tools', 'equipment']
    },
    {
        name: 'Vendors',
        displayName: 'Vendors',
        featureKey: 'frontend_vendors',
        icon: <BusinessIcon fontSize="large" />,
        link: '/vendors',
        color: '#607d8b',
        description: 'Vendor Management',
        category: 'operations',
        searchTerms: ['operations', 'vendors', 'suppliers', 'contractor']
    },
    {
        name: 'Employees',
        displayName: 'Employees',
        featureKey: 'frontend_employees',
        icon: <PeopleIcon fontSize="large" />,
        link: '/employees/list',
        color: '#009688',
        description: 'Employee Directory',
        category: 'operations',
        searchTerms: ['operations', 'employees', 'staff', 'directory', 'workers']
    },
    {
        name: 'Hold Harmless Form',
        displayName: 'Hold Harmless Form',
        featureKey: 'frontend_hold_harmless',
        icon: <AssignmentIcon fontSize="large" />,
        link: '/temps/exhibit-b/list',
        color: '#1976d2',
        description: 'Acknowledgement Forms',
        category: 'operations',
        searchTerms: ['operations', 'hold harmless', 'exhibit b', 'acknowledgement']
    },
    {
        name: 'Post-Work Area Turnover',
        displayName: 'Post-Work Area Turnover',
        featureKey: 'post_work_area_turnover',
        icon: <AssignmentIcon fontSize="large" />,
        link: '/forms/post-work-area-turnover/list',
        color: '#1976d2',
        description: 'Turnover record with job & signatures',
        category: 'operations',
        searchTerms: ['operations', 'turnover', 'post work', 'area turnover']
    },
    {
        name: 'Employee Warning Notice',
        displayName: 'Employee Warning Notice',
        featureKey: 'frontend_employee_warning',
        icon: <AssignmentIcon fontSize="large" />,
        link: '/forms/employee-warning-notice/list',
        color: '#1976d2',
        description: 'Employee warning documentation',
        category: 'operations',
        searchTerms: ['operations', 'warning', 'notice', 'employee warning', 'discipline']
    },
    {
        name: 'Welder Qualification & Release',
        displayName: 'On-Site Welder Qualification & Release',
        featureKey: 'frontend_welder_qualification_release',
        icon: <LocalFireDepartmentIcon fontSize="large" />,
        link: '/operations/welder-qualification-release',
        color: '#ef6c00',
        description: 'LC-36A site release for pipe / tubular field welding',
        category: 'operations',
        searchTerms: ['operations', 'welder', 'welding', 'qualification', 'release', 'qc', 'cwi', 'wps', 'pqr', 'lc-36a', 'pipe', 'tubular']
    },
    {
        name: 'Change Order / Extra Work',
        displayName: 'Change Order / Extra Work',
        featureKey: 'change_order',
        icon: <ChangeCircleIcon fontSize="large" />,
        link: '/operations/change-order',
        color: '#ff5722',
        description: 'Change Order and Extra Work documentation',
        category: 'operations',
        searchTerms: ['operations', 'change order', 'extra work', 'work order', 'modification']
    },
    {
        name: 'Scope of Work',
        displayName: 'Scope of Work',
        featureKey: 'scope_of_work',
        icon: <DescriptionIcon fontSize="large" />,
        link: '/operations/scope-of-work',
        color: '#5c6bc0',
        description: 'Scope of Work documentation',
        category: 'operations',
        searchTerms: ['operations', 'scope of work', 'sow']
    },
    {
        name: 'Warranty',
        displayName: 'Warranty',
        featureKey: 'warranty',
        icon: <AssignmentIcon fontSize="large" />,
        link: '/operations/warranty',
        color: '#9c27b0',
        description: 'Warranty documentation',
        category: 'operations',
        searchTerms: ['operations', 'warranty', 'guarantee', 'completion']
    },
    {
        name: 'Equipment List',
        displayName: 'Equipment List',
        featureKey: 'equipment_list',
        icon: <BuildIcon fontSize="large" />,
        link: '/operations/equipment-list',
        color: '#455a64',
        description: 'Internal & Rental equipment by job',
        category: 'tools_equipment',
        searchTerms: ['tools', 'equipment', 'rental', 'internal', 'purchase order', 'po', 'call off']
    },
    {
        name: 'Equipment Inspection',
        displayName: 'Equipment Inspection',
        featureKey: 'frontend_ext_equipment',
        icon: <BuildIcon fontSize="large" />,
        link: '/operations/ext-equipment/scan',
        color: '#00897b',
        description: 'QR tag, link & inspect rental equipment',
        category: 'tools_equipment',
        searchTerms: ['tools', 'equipment', 'inspection', 'qr', 'rental', 'daily check', 'forklift', 'crane', 'aerial lift']
    },
    {
        name: 'SRD Inspection',
        displayName: 'SRD Inspection',
        featureKey: 'frontend_srd_inspection',
        icon: <ShieldIcon fontSize="large" />,
        link: '/operations/srd-inspection',
        color: '#1565c0',
        description: 'Self-Retracting Device inspection',
        category: 'operations',
        searchTerms: ['tools', 'equipment', 'srd', 'self-retracting', 'retractable', 'fall protection', 'inspection']
    },
    {
        name: 'CC',
        displayName: 'CC',
        featureKey: 'frontend_cc',
        icon: <CreditCard fontSize="large" />,
        link: '/cc',
        color: '#4caf50',
        description: 'Credit Cards',
        category: 'operations',
        searchTerms: ['operations', 'cc', 'credit card', 'card', 'expenses']
    },
    {
        name: 'PO',
        displayName: 'PO',
        featureKey: 'frontend_po',
        icon: <NotesIcon fontSize="large" />,
        link: '/po',
        color: '#ff9800',
        description: 'In Development',
        category: 'operations',
        searchTerms: ['operations', 'po', 'purchase order', 'order']
    },
    // Piping category - Information
    {
        name: 'General Piping Torque Procedure',
        displayName: 'General Piping Torque Procedure',
        featureKey: 'frontend_piping_torque',
        icon: <SettingsIcon fontSize="large" />,
        link: '/piping/information/general-torque-procedure',
        description: 'Bolt tightening specs',
        category: 'piping',
        searchTerms: ['piping', 'torque', 'procedure', 'bolt', 'tightening', 'specs']
    },
    {
        name: 'ANSI Flange Specifications',
        displayName: 'ANSI Flange Specifications',
        featureKey: 'frontend_ansi_flange',
        icon: <DocumentIcon fontSize="large" />,
        link: '/piping/information/flange-specifications',
        description: 'Flange bolt requirements',
        category: 'piping',
        searchTerms: ['piping', 'ansi', 'flange', 'specifications', 'bolt', 'requirements']
    },
    {
        name: 'Piping General Testing',
        displayName: 'Piping, General Testing',
        featureKey: 'frontend_piping_testing',
        icon: <InfoIcon fontSize="large" />,
        link: '/piping/information/piping-general-testing',
        description: 'Testing specifications',
        category: 'piping',
        searchTerms: ['piping', 'testing', 'general', 'specifications']
    },
    // Piping category - Forms
    {
        name: 'Pipe Hydro Test',
        displayName: 'Pipe Hydro Test',
        featureKey: 'pipe_hydro_test',
        icon: <WaterDropIcon fontSize="large" />,
        link: '/piping/forms/pipe-hydro-test/list',
        description: 'Hydrostatic testing',
        category: 'piping',
        searchTerms: ['piping', 'pipe', 'hydro', 'hydrostatic', 'test', 'water test']
    },
    {
        name: 'Vessel Hydro Test',
        displayName: 'Vessel Hydro Test',
        featureKey: 'vessel_hydro_test',
        icon: <WaterDropIcon fontSize="large" />,
        link: '/piping/forms/vessel-hydro-test/list',
        description: 'Vessel testing form',
        category: 'piping',
        searchTerms: ['piping', 'vessel', 'hydro', 'hydrostatic', 'test', 'pressure']
    },
    {
        name: 'Service Leak Test',
        displayName: 'Service Leak Test',
        featureKey: 'service_leak_test',
        icon: <ChecklistIcon fontSize="large" />,
        link: '/piping/forms/service-leak-test/list',
        description: 'Leak testing report',
        category: 'piping',
        searchTerms: ['piping', 'service', 'leak', 'test', 'inspection']
    },
    {
        name: 'Weld Map',
        displayName: 'Weld Map',
        featureKey: 'weld_map',
        icon: <MapIcon fontSize="large" />,
        link: '/piping/forms/weld-map/list',
        description: 'Weld inspection tracking',
        category: 'piping',
        searchTerms: ['piping', 'weld', 'map', 'welding', 'inspection', 'tracking']
    },
    {
        name: 'Pneumatic Test',
        displayName: 'Pneumatic Test',
        featureKey: 'pneumatic_test',
        icon: <PlumbingIcon fontSize="large" />,
        link: '/piping/forms/pneumatic-test/list',
        description: 'Pneumatic pressure testing',
        category: 'piping',
        searchTerms: ['piping', 'pneumatic', 'test', 'air', 'pressure']
    },
    {
        name: 'Torque Map',
        displayName: 'Torque Map',
        featureKey: 'torque_map',
        icon: <MapIcon fontSize="large" />,
        link: '/piping/forms/torque-map/list',
        description: 'Torque inspection tracking',
        category: 'piping',
        searchTerms: ['piping', 'torque', 'map', 'inspection', 'tracking', 'bolt']
    },
    {
        name: 'Gas Line Inspection',
        displayName: 'Gas Line Inspection',
        featureKey: 'gas_line_inspection',
        icon: <ChecklistIcon fontSize="large" />,
        link: '/piping/forms/gas-line-inspection/list',
        description: 'Visual inspection report',
        category: 'piping',
        searchTerms: ['piping', 'gas', 'line', 'inspection', 'visual', 'report']
    },
    // Electrical category
    {
        name: 'Megger Test Report',
        displayName: 'Megger Test Report',
        featureKey: 'megger_test',
        icon: <ElectricBoltIcon fontSize="large" />,
        link: '/electrical/forms/megger-test/list',
        description: 'Electrical insulation testing report',
        category: 'electrical',
        searchTerms: ['electrical', 'megger', 'test', 'insulation', 'electrical testing', 'report']
    },
    {
        name: 'Terminal Torque Test Report',
        displayName: 'Terminal Torque Test Report',
        featureKey: 'terminal_torque_test',
        icon: <ElectricBoltIcon fontSize="large" />,
        link: '/electrical/forms/terminal-torque-test/list',
        description: 'Terminal torque testing report',
        category: 'electrical',
        searchTerms: ['electrical', 'terminal', 'torque', 'test', 'electrical testing', 'report']
    },
    {
        name: 'Panel Shop Q/C Checklist',
        displayName: 'Panel Shop Q/C Checklist',
        featureKey: 'panel_shop_qc',
        icon: <ChecklistIcon fontSize="large" />,
        link: '/electrical/forms/panel-shop-qc/list',
        description: 'Panel shop quality control checklist',
        category: 'electrical',
        searchTerms: ['electrical', 'panel', 'shop', 'qc', 'quality', 'control', 'checklist']
    },
    {
        name: 'Bus Inspection Report',
        displayName: 'Bus Inspection Report',
        featureKey: 'bus_inspection',
        icon: <ElectricBoltIcon fontSize="large" />,
        link: '/electrical/forms/bus-inspection/list',
        description: 'Bus plug and panel inspection report',
        category: 'electrical',
        searchTerms: ['electrical', 'bus', 'inspection', 'busduct', 'plug', 'panel', 'report']
    },
    {
        name: 'Cable Wiring Schedule',
        displayName: 'Cable Wiring Schedule',
        featureKey: 'cable_wiring_schedule',
        icon: <ElectricBoltIcon fontSize="large" />,
        link: '/electrical/cable-wiring-schedule',
        description: 'Cable wiring and conductor schedule',
        category: 'electrical',
        searchTerms: ['electrical', 'cable', 'wiring', 'schedule', 'conductor', 'wire']
    },
    {
        name: 'Energized Electrical Work Permit',
        displayName: 'Energized Work Permit',
        featureKey: 'energized_work_permit',
        icon: <ElectricBoltIcon fontSize="large" />,
        link: '/electrical/energized-work-permit',
        description: 'Permit for work on energized electrical equipment',
        category: 'electrical',
        searchTerms: ['electrical', 'energized', 'work', 'permit', 'safety', 'hot', 'work']
    },
    {
        name: 'Packing Slip',
        displayName: 'Packing Slip',
        featureKey: 'packing_slip',
        icon: <DocumentIcon fontSize="large" />,
        link: '/electrical/packing-slip/list',
        description: 'Material packing and shipping slip',
        category: 'electrical',
        searchTerms: ['electrical', 'packing', 'slip', 'shipping', 'materials', 'delivery']
    }
];
